module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sForm.ad_status === 3) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": _vm.errorTip,
      "type": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "12.5%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sForm.ad_id),
      expression: "sForm.ad_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.sForm.ad_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sForm, "ad_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name'),
      "prop": "ad_title"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify')
    }
  }, _vm._l((_vm.adTypeList), function(item, index) {
    return (item.adtypeId == _vm.sForm.ad_type) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position')
    }
  }, [(_vm.sForm.ad_position == 0) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.banner')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_position == 1) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.starPage')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_position == 3) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [(_vm.sForm.ad_Urltype == '0') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype == '1') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))]) : _vm._e()]), _vm._v(" "), (_vm.sForm.ad_Urltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.appName))])]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_url))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.channel'),
      "prop": "ad_channel"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_channel_name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.sForm.ad_start_date)))])]), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.sForm.ad_start_end)))])])], 1), _vm._v(" "), (_vm.sForm.ad_id && _vm.sForm.ad_imgUrl) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + _vm.sForm.ad_imgUrl,
      "width": "100%"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), (_vm.sForm.ad_status == 0 || _vm.sForm.ad_status == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpdate
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.update')))]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a63bb86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advert/detail.vue
// module id = 963
// module chunks = 0